<template>
  <v-combobox
    v-bind="$attrs"
    v-on="$listeners"
    :item-text="itemText"
    :item-value="itemValue"
    :return-object="false"
    :multiple="multiple"
  >
    <template v-slot:prepend-item>
      <v-list-item ripple @mousedown.prevent @click="toggleAll">
        <v-list-item-action>
          <v-icon :color="$attrs.value.length > 0 ? 'indigo darken-4' : ''">
            {{ icon }}
          </v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title> Select All </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mt-2"></v-divider>
    </template>
    <template v-slot:selection="{ item, index }">
      <span v-if="index === 0">{{ item }}</span>
      <span v-if="index === 1" class="grey--text text-caption">
        ( +{{ $attrs.value.length - 1 }} others)
      </span>
    </template>
  </v-combobox>
</template>

<script>
export default {
  name: "ExSelect",
  props: {
    itemText: {
      default: "name",
    },
    itemValue: {
      default: "value",
    },
    multiple: {
      default: true,
    },
  },
  computed: {
    selectedAll() {
      return this.$attrs.value.length === this.$attrs.items.length;
    },
    selectedSome() {
      return this.$attrs.value.length > 0 && !this.selectedAll;
    },
    icon() {
      if (this.selectedAll) return "mdi-close-box";
      if (this.selectedSome) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },
  methods: {
    toggleAll() {
      this.$nextTick(() => {
        if (this.selectedAll) {
          this.$emit("input", []);
        } else {
          this.$emit(
            "input",
            this.$attrs.items.map(({ value }) => value)
          );
        }
        this.$emit("change");
      });
    },
  },
};
</script>
